/* Package JSON Import will be here */
import { findIndex, sumBy } from "lodash";
/* Package JSON Import will be here */

/* Project Import will be here */
import { getErrorObject, errorToast } from "../../utilities/utils";
import Constants from "utilities/appConstants";
import { showMsgFromJson } from "reducers/common";
import {
    rewardOrderConfirmRequestOTPApi,
    rewardOrderConfirmValidateOTPApi,
    submitRewardOrderApi
} from "services/rewards/rewards";
import { navigateToMyRewards, navigateToRedemptionHistory } from "app/navigation";
import { clearHistoryFilter } from "reducers/orderHistory/historyFilter";
/* Project Import will be here */

export const types = {
    REWARDS_ORDER_OTP_REQUEST: "rewardsOrderSummary/REWARDS_ORDER_OTP_REQUEST",
    REWARDS_ORDER_OTP_SUCCESS: "rewardsOrderSummary/REWARDS_ORDER_OTP_SUCCESS",
    REWARDS_ORDER_OTP_CLOSE: "rewardsOrderSummary/REWARDS_ORDER_OTP_CLOSE",
    REWARDS_ORDER_SUMMARY_UPDATE_PRODUCT_QTY: "rewardsOrderSummary/REWARDS_ORDER_SUMMARY_UPDATE_PRODUCT_QTY",
    RESET_REWARD_SUMMARY: "rewardsOrderSummary/RESET_REWARD_SUMMARY",
    REWARDS_ORDER_SUBMIT_REQUEST: "rewardsOrderSummary/REWARDS_ORDER_SUBMIT_REQUEST",
    REWARDS_ORDER_SUBMIT_RESPONSE: "rewardsOrderSummary/REWARDS_ORDER_SUBMIT_RESPONSE"
};

const initialState = {
    productList: [],
    totalPoints: 0,
    totalQty: 0,
    isLoading: false,
    error: null,
    otp: {
        isShowOtpModal: false,
        isLoading: false
    },
};

export const rewardsOrderSummary = (state = initialState, action) => {
    switch (action.type) {
        /* Update Qty */
        case types.REWARDS_ORDER_SUMMARY_UPDATE_PRODUCT_QTY:
            return {
                ...state,
                ...action.payload
            };

        /* OTP */
        case types.REWARDS_ORDER_OTP_REQUEST:
            return {
                ...state,
                otp: {
                    isShowOtpModal: true,
                    isLoading: true
                }
            };
        case types.REWARDS_ORDER_OTP_SUCCESS:
            return {
                ...state,
                otp: {
                    isShowOtpModal: true,
                    isLoading: false
                }
            };
        case types.REWARDS_ORDER_OTP_CLOSE:
            return {
                ...state,
                otp: {
                    isShowOtpModal: false,
                    isLoading: false
                }
            };

        /* Order Upload */
        case types.REWARDS_ORDER_SUBMIT_REQUEST:
            return {
                ...state,
                isLoading: true
            };
        case types.REWARDS_ORDER_SUBMIT_RESPONSE:
            return {
                ...state,
                ...action.payload,
                isLoading: false
            };

        /* Clear SUmmary */
        case types.RESET_REWARD_SUMMARY:
            return {
                productList: [],
                isLoading: false,
                error: null,
                otp: {
                    isShowOtpModal: false,
                    isLoading: false
                },
            };
        default:
            return state;
    }
};

/* OTP initialization */
export const sendRewardConfirmationOTP = () => {
    return async (dispatch, getState) => {
        dispatch({ type: types.REWARDS_ORDER_OTP_REQUEST });
        try {
            await rewardOrderConfirmRequestOTPApi();
            dispatch({ type: types.REWARDS_ORDER_OTP_SUCCESS });
        }
        catch (error) {
            dispatch(promiseCatchBlock(error, types.REWARDS_ORDER_OTP_CLOSE, true));
        }
    };
};

/* Close OTP modal */
export const hideOtpModal = () => {
    return {
        type: types.REWARDS_ORDER_OTP_CLOSE
    };
};

/* Validate reward order OTP */
export const orderConfirmValidateOTP = (otp) => {
    return async (dispatch, getState) => {
        dispatch({ type: types.REWARDS_ORDER_OTP_REQUEST });
        try {
            /* Validate OTP */
            await rewardOrderConfirmValidateOTPApi({ RewardOrderOTP: otp });

            /* After OTP validated place the reward order */
            await dispatch(submitRewardOrder());

            dispatch({ type: types.REWARDS_ORDER_OTP_CLOSE });
        }
        catch (error) {
            dispatch(promiseCatchBlock(error, types.REWARDS_ORDER_OTP_CLOSE, true));
        }
    };
};

export const updateProductQty = (product, value) => {
    return async (dispatch, getState) => {
        /* Check the product existence */
        const tempSummaryProducts = getState().rewardsOrderSummary.productList;
        const selectedProductIndex = findIndex(tempSummaryProducts, (o) => {
            return o.ProductId === product.ProductId;
        });

        /* Validate the order points by available points */
        const availablePoints = getState().rewardDashboard.data.RewardPoints;
        let addedPoints = sumBy(tempSummaryProducts, (o) => { return o.TotalPoints; });
        addedPoints = (selectedProductIndex !== -1) ? (addedPoints - tempSummaryProducts[selectedProductIndex].TotalPoints) : addedPoints;
        addedPoints = addedPoints + (value * product.ProductPoints);

        if (addedPoints <= availablePoints) {

            if (selectedProductIndex !== -1) {
                if (value === 0) {
                    tempSummaryProducts.splice(selectedProductIndex, 1);
                }
                else {
                    tempSummaryProducts[selectedProductIndex].Qty = value;
                    tempSummaryProducts[selectedProductIndex].TotalPoints = (value * product.ProductPoints);
                }
            }
            else {
                /* Add the product object newly */
                const newProduct = {
                    ...product,
                    Qty: value,
                    TotalPoints: (value * product.ProductPoints)
                }

                tempSummaryProducts.push(newProduct);
            }

            dispatch({
                type: types.REWARDS_ORDER_SUMMARY_UPDATE_PRODUCT_QTY,
                payload: {
                    productList: tempSummaryProducts,
                    totalPoints: addedPoints,
                    totalQty: sumBy(tempSummaryProducts, (o) => { return o.Qty; })
                }
            });
        }
        else {
            dispatch(showMsgFromJson('rewards.summary.pointValidation', Constants.ERROR));
        }
    };
};

/* Submit reward order */
export const submitRewardOrder = () => {
    return async (dispatch, getState) => {
        dispatch({ type: types.REWARDS_ORDER_SUBMIT_REQUEST });
        try {
            const reqObj = {
                vendorId: getState().rewardsAttrFilter.selectedVendor.length > 0 ? getState().rewardsAttrFilter.selectedVendor[0] : 0,
                productList: getState().rewardsOrderSummary.productList,
                redeemType: getState().rewardDashboard.selectedRedeemType,
                totalRedeemPoint: getState().rewardDashboard.selectedRedeemType === Constants.PRODUCT ? sumBy(getState().rewardsOrderSummary.productList, (product) => product.TotalPoints || 0) : getState().rewardDashboard.cashPoints,
            };
            const response = await submitRewardOrderApi(reqObj);
            dispatch({ type: types.REWARDS_ORDER_SUBMIT_RESPONSE });
            dispatch(placeOrderResponseAction(response.data.Data));
        }
        catch (error) {
            dispatch(promiseCatchBlock(error, types.REWARDS_ORDER_SUBMIT_RESPONSE, true));
        }
    }
};

const placeOrderResponseAction = (response) => {
    return async (dispatch, getState) => {
        /* Navigate to the retailer to the respective response page */
        dispatch(showMsgFromJson(`rewards.redemptionsSuccess`, Constants.SUCCESS));
        /*To clear history filter*/
        await dispatch(clearHistoryFilter());

        dispatch(navigateToRedemptionHistory());

        /* Reset reward order summary */
        dispatch({ type: types.RESET_REWARD_SUMMARY });
    }
}

/* Clear all rewards product summary items */
export const clearRedemptionCart = () => {
    return async (dispatch, getState) => {
        dispatch({ type: types.RESET_REWARD_SUMMARY });
        dispatch(showMsgFromJson(`common.alerts.success.clearCartSuccess`, Constants.SUCCESS));
        dispatch(navigateToMyRewards());
    };
};

export const clearRedemptionCartAfterNavigation = () => {
    return async (dispatch, getState) => {
        dispatch({ type: types.RESET_REWARD_SUMMARY });
    };
};
/* Generic code for promise catch block */
const promiseCatchBlock = (error: any, type: string, showToast: boolean = false) => {
    return (dispatch) => {
        const { message, errorCode } = getErrorObject(error);

        /* Update the error response in the store */
        if (type !== "")
            dispatch({ type: type, payload: { error: message } });

        /* Show error message */
        if (showToast) {
            /* If error code is exist show the error code message or show the error message returned by the API request */
            if (errorCode !== "")
                dispatch(showMsgFromJson(`common.alerts.error.${errorCode}`, Constants.ERROR));
            else
                errorToast({ content: message });
        }
    }
};